import { createI18n } from 'vue-i18n';
import { STORAGE_KEYS, LANGUAGE_OPTIONS, LOCALE, DEFAULT_LOCALE } from '@/shared/constants/app';
import dayjs from '@/core/boot/day';
import storageService from '@/shared/services/storage.service';
import en from './locales/en';

export const SUPPORTED_LOCALES = LANGUAGE_OPTIONS.map(({ code }) => code);
const localeLoaders = {
  [LOCALE.CHINESE]: () => import('./locales/zh'),
};
const loadedLocales = new Set([DEFAULT_LOCALE]);

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { [LOCALE.ENGLISH]: en },
});

export function normalizeLocale(value) {
  const code = String(value || '')
    .toLowerCase()
    .split('-')[0];
  if (SUPPORTED_LOCALES.includes(code)) {
    return code;
  }
  return DEFAULT_LOCALE;
}

export async function setI18nLocale(value) {
  const locale = normalizeLocale(value);
  if (!loadedLocales.has(locale)) {
    const { default: messages } = await localeLoaders[locale]();
    i18n.global.setLocaleMessage(locale, messages);
    loadedLocales.add(locale);
  }
  await storageService.setItem(STORAGE_KEYS.LANGUAGE_KEY, locale);
  i18n.global.locale.value = locale;
  dayjs.locale(locale);
  document.documentElement.lang = locale;
  return locale;
}

export async function initializeI18n() {
  const stored = await storageService.getItem(STORAGE_KEYS.LANGUAGE_KEY);
  await setI18nLocale(stored);
}

export default i18n;
